//GET_LEAVE_OF_USERS_BY_ID
export const GET_LEAVE_OF_USERS_BY_ID_REQUEST =
  "GET_LEAVE_OF_USERS_BY_ID_REQUEST";
export const GET_LEAVE_OF_USERS_BY_ID_SUCCESS =
  "GET_LEAVE_OF_USERS_BY_ID_SUCCESS";
export const GET_LEAVE_OF_USERS_BY_ID_FAIL = "GET_LEAVE_OF_USERS_BY_ID_FAIL";

//GET_LEAVE_OF_USERS_BY_COMPANY
export const GET_LEAVE_OF_USERS_BY_COMPANY_REQUEST =
  "GET_LEAVE_OF_USERS_BY_COMPANY_REQUEST";
export const GET_LEAVE_OF_USERS_BY_COMPANY_SUCCESS =
  "GET_LEAVE_OF_USERS_BY_COMPANY_SUCCESS";
export const GET_LEAVE_OF_USERS_BY_COMPANY_FAIL =
  "GET_LEAVE_OF_USERS_BY_COMPANY_FAIL";

//ADD_LEAVE_OF_USERS
export const ADD_LEAVE_OF_USERS_REQUEST = "ADD_LEAVE_OF_USERS_REQUEST";
export const ADD_LEAVE_OF_USERS_SUCCESS = "ADD_LEAVE_OF_USERS_SUCCESS";
export const ADD_LEAVE_OF_USERS_FAIL = "ADD_LEAVE_OF_USERS_FAIL";

//ADD_LEAVE_USER_SETTING
export const ADD_LEAVE_USER_SETTING_REQUEST = "ADD_LEAVE_USER_SETTING_REQUEST";
export const ADD_LEAVE_USER_SETTING_SUCCESS = "ADD_LEAVE_USER_SETTING_SUCCESS";
export const ADD_LEAVE_USER_SETTING_FAIL = "ADD_LEAVE_USER_SETTING_FAIL";
//SET_APPROVER_STAGES_FOR_LEAVE
export const SET_APPROVER_STAGES_FOR_LEAVE_REQUEST =
  "SET_APPROVER_STAGES_FOR_LEAVE_REQUEST";
export const SET_APPROVER_STAGES_FOR_LEAVE_SUCCESS =
  "SET_APPROVER_STAGES_FOR_LEAVE_SUCCESS";
export const SET_APPROVER_STAGES_FOR_LEAVE_FAIL =
  "SET_APPROVER_STAGES_FOR_LEAVE_FAIL";

//SET_APPROVER_STAGES_FOR_LEAVE_DEPARTMENT
export const SET_APPROVER_STAGES_FOR_LEAVE_DEPARTMENT_REQUEST =
  "SET_APPROVER_STAGES_FOR_LEAVE_DEPARTMENT_REQUEST";
export const SET_APPROVER_STAGES_FOR_LEAVE_DEPARTMENT_SUCCESS =
  "SET_APPROVER_STAGES_FOR_LEAVE_DEPARTMENT_SUCCESS";
export const SET_APPROVER_STAGES_FOR_LEAVE_DEPARTMENT_FAIL =
  "SET_APPROVER_STAGES_FOR_LEAVE_DEPARTMENT_FAIL";
//ADD_LEAVE_OF_USERS_APPROVE
export const ADD_LEAVE_OF_USERS_APPROVE_REQUEST =
  "ADD_LEAVE_OF_USERS_APPROVE_REQUEST";
export const ADD_LEAVE_OF_USERS_APPROVE_SUCCESS =
  "ADD_LEAVE_OF_USERS_APPROVE_SUCCESS";
export const ADD_LEAVE_OF_USERS_APPROVE_FAIL =
  "ADD_LEAVE_OF_USERS_APPROVE_FAIL";

//ADD_LEAVE_OF_USERS_REJECT
export const ADD_LEAVE_OF_USERS_REJECT_REQUEST =
  "ADD_LEAVE_OF_USERS_REJECT_REQUEST";
export const ADD_LEAVE_OF_USERS_REJECT_SUCCESS =
  "ADD_LEAVE_OF_USERS_REJECT_SUCCESS";
export const ADD_LEAVE_OF_USERS_REJECT_FAIL = "ADD_LEAVE_OF_USERS_REJECT_FAIL";

//DELETE_LEAVE_OF_USERS
export const DELETE_LEAVE_OF_USERS_REQUEST = "DELETE_LEAVE_OF_USERS_REQUEST";
export const DELETE_LEAVE_OF_USERS_SUCCESS = "DELETE_LEAVE_OF_USERS_SUCCESS";
export const DELETE_LEAVE_OF_USERS_FAIL = "DELETE_LEAVE_OF_USERS_FAIL";

//ADD_LEAVE_SETTING_IN_ALL_COMPANY
export const ADD_LEAVE_SETTING_IN_ALL_COMPANY_REQUEST =
  "ADD_LEAVE_SETTING_IN_ALL_COMPANY_REQUEST";
export const ADD_LEAVE_SETTING_IN_ALL_COMPANY_SUCCESS =
  "ADD_LEAVE_SETTING_IN_ALL_COMPANY_SUCCESS";
export const ADD_LEAVE_SETTING_IN_ALL_COMPANY_FAIL =
  "ADD_LEAVE_SETTING_IN_ALL_COMPANY_FAIL";

//GET_LEAVE_SETTING_IN_ALL_COMPANY
export const GET_LEAVE_SETTING_IN_ALL_COMPANY_REQUEST =
  "GET_LEAVE_SETTING_IN_ALL_COMPANY_REQUEST";
export const GET_LEAVE_SETTING_IN_ALL_COMPANY_SUCCESS =
  "GET_LEAVE_SETTING_IN_ALL_COMPANY_SUCCESS";
export const GET_LEAVE_SETTING_IN_ALL_COMPANY_FAIL =
  "GET_LEAVE_SETTING_IN_ALL_COMPANY_FAIL";

//ADD_LEAVE_SETTING_FOR_USER
export const ADD_LEAVE_SETTING_FOR_USER_REQUEST =
  "ADD_LEAVE_SETTING_FOR_USER_REQUEST";
export const ADD_LEAVE_SETTING_FOR_USER_SUCCESS =
  "ADD_LEAVE_SETTING_FOR_USER_SUCCESS";
export const ADD_LEAVE_SETTING_FOR_USER_FAIL =
  "ADD_LEAVE_SETTING_FOR_USER_FAIL";

//ADD_WORKING_IN_LEAVE_SETTING
export const ADD_WORKING_IN_LEAVE_SETTING_REQUEST =
  "ADD_WORKING_IN_LEAVE_SETTING_REQUEST";
export const ADD_WORKING_IN_LEAVE_SETTING_SUCCESS =
  "ADD_WORKING_IN_LEAVE_SETTING_SUCCESS";
export const ADD_WORKING_IN_LEAVE_SETTING_FAIL =
  "ADD_WORKING_IN_LEAVE_SETTING_FAIL";

//ADD_LATE_TIME
export const ADD_LATE_TIME_REQUEST = "ADD_LATE_TIME_REQUEST";
export const ADD_LATE_TIME_SUCCESS = "ADD_LATE_TIME_SUCCESS";
export const ADD_LATE_TIME_FAIL = "ADD_LATE_TIME_FAIL";

//GET_LATE_TIME
export const GET_LATE_TIME_REQUEST = "GET_LATE_TIME_REQUEST";
export const GET_LATE_TIME_SUCCESS = "GET_LATE_TIME_SUCCESS";
export const GET_LATE_TIME_FAIL = "GET_LATE_TIME_FAIL";

//CREATE_PUBLIC_HOLIDAY
export const CREATE_PUBLIC_HOLIDAY_REQUEST = "CREATE_PUBLIC_HOLIDAY_REQUEST";
export const CREATE_PUBLIC_HOLIDAY_SUCCESS = "CREATE_PUBLIC_HOLIDAY_SUCCESS";
export const CREATE_PUBLIC_HOLIDAY_FAIL = "CREATE_PUBLIC_HOLIDAY_FAIL";

//UPDATE_PUBLIC_HOLIDAY
export const UPDATE_PUBLIC_HOLIDAY_REQUEST = "UPDATE_PUBLIC_HOLIDAY_REQUEST";
export const UPDATE_PUBLIC_HOLIDAY_SUCCESS = "UPDATE_PUBLIC_HOLIDAY_SUCCESS";
export const UPDATE_PUBLIC_HOLIDAY_FAIL = "UPDATE_PUBLIC_HOLIDAY_FAIL";

//GET_ONE_PUBLIC_HOLIDAY
export const GET_ONE_PUBLIC_HOLIDAY_REQUEST = "GET_ONE_PUBLIC_HOLIDAY_REQUEST";
export const GET_ONE_PUBLIC_HOLIDAY_SUCCESS = "GET_ONE_PUBLIC_HOLIDAY_SUCCESS";
export const GET_ONE_PUBLIC_HOLIDAY_FAIL = "GET_ONE_PUBLIC_HOLIDAY_FAIL";

//GET_ALL_PUBLIC_HOLIDAY
export const GET_ALL_PUBLIC_HOLIDAY_REQUEST = "GET_ALL_PUBLIC_HOLIDAY_REQUEST";
export const GET_ALL_PUBLIC_HOLIDAY_SUCCESS = "GET_ALL_PUBLIC_HOLIDAY_SUCCESS";
export const GET_ALL_PUBLIC_HOLIDAY_FAIL = "GET_ALL_PUBLIC_HOLIDAY_FAIL";

//ASSIGN_PUBLIC_HOLIDAY
export const ASSIGN_PUBLIC_HOLIDAY_REQUEST = "ASSIGN_PUBLIC_HOLIDAY_REQUEST";
export const ASSIGN_PUBLIC_HOLIDAY_SUCCESS = "ASSIGN_PUBLIC_HOLIDAY_SUCCESS";
export const ASSIGN_PUBLIC_HOLIDAY_FAIL = "ASSIGN_PUBLIC_HOLIDAY_FAIL";

//DELETE_PUBLIC_HOLIDAY
export const DELETE_PUBLIC_HOLIDAY_REQUEST = "DELETE_PUBLIC_HOLIDAY_REQUEST";
export const DELETE_PUBLIC_HOLIDAY_SUCCESS = "DELETE_PUBLIC_HOLIDAY_SUCCESS";
export const DELETE_PUBLIC_HOLIDAY_FAIL = "DELETE_PUBLIC_HOLIDAY_FAIL";

//CREATE_NEW_LEAVE_TYPE
export const CREATE_NEW_LEAVE_TYPE_REQUEST = "CREATE_NEW_LEAVE_TYPE_REQUEST";
export const CREATE_NEW_LEAVE_TYPE_SUCCESS = "CREATE_NEW_LEAVE_TYPE_SUCCESS";
export const CREATE_NEW_LEAVE_TYPE_FAIL = "CREATE_NEW_LEAVE_TYPE_FAIL";

//UPDATE_NEW_LEAVE_TYPE
export const UPDATE_NEW_LEAVE_TYPE_REQUEST = "UPDATE_NEW_LEAVE_TYPE_REQUEST";
export const UPDATE_NEW_LEAVE_TYPE_SUCCESS = "UPDATE_NEW_LEAVE_TYPE_SUCCESS";
export const UPDATE_NEW_LEAVE_TYPE_FAIL = "UPDATE_NEW_LEAVE_TYPE_FAIL";

//UPDATE_NEW_LEAVE_TYPE_STATUS
export const UPDATE_NEW_LEAVE_TYPE_STATUS_REQUEST =
  "UPDATE_NEW_LEAVE_TYPE_STATUS_REQUEST";
export const UPDATE_NEW_LEAVE_TYPE_STATUS_SUCCESS =
  "UPDATE_NEW_LEAVE_TYPE_STATUS_SUCCESS";
export const UPDATE_NEW_LEAVE_TYPE_STATUS_FAIL =
  "UPDATE_NEW_LEAVE_TYPE_STATUS_FAIL";

//ARCHIVE_NEW_LEAVE_TYPE
export const ARCHIVE_NEW_LEAVE_TYPE_REQUEST = "ARCHIVE_NEW_LEAVE_TYPE_REQUEST";
export const ARCHIVE_NEW_LEAVE_TYPE_SUCCESS = "ARCHIVE_NEW_LEAVE_TYPE_SUCCESS";
export const ARCHIVE_NEW_LEAVE_TYPE_FAIL = "ARCHIVE_NEW_LEAVE_TYPE_FAIL";

//GET_NEW_LEAVE_TYPE
export const GET_NEW_LEAVE_TYPE_REQUEST = "GET_NEW_LEAVE_TYPE_REQUEST";
export const GET_NEW_LEAVE_TYPE_SUCCESS = "GET_NEW_LEAVE_TYPE_SUCCESS";
export const GET_NEW_LEAVE_TYPE_FAIL = "GET_NEW_LEAVE_TYPE_FAIL";

//GET_ALL_LEAVE_REQUESTS
export const GET_ALL_LEAVE_REQUESTS_REQUEST = "GET_ALL_LEAVE_REQUESTS_REQUEST";
export const GET_ALL_LEAVE_REQUESTS_SUCCESS = "GET_ALL_LEAVE_REQUESTS_SUCCESS";
export const GET_ALL_LEAVE_REQUESTS_FAIL = "GET_ALL_LEAVE_REQUESTS_FAIL";

//GET_ALL_LEAVE_HISTORY
export const GET_ALL_LEAVE_HISTORY_REQUEST = "GET_ALL_LEAVE_HISTORY_REQUEST";
export const GET_ALL_LEAVE_HISTORY_SUCCESS = "GET_ALL_LEAVE_HISTORY_SUCCESS";
export const GET_ALL_LEAVE_HISTORY_FAIL = "GET_ALL_LEAVE_HISTORY_FAIL";

//DOWNLOAD_LEAVE_REQ_PDF
export const DOWNLOAD_LEAVE_REQ_PDF_REQUEST = "DOWNLOAD_LEAVE_REQ_PDF_REQUEST";
export const DOWNLOAD_LEAVE_REQ_PDF_SUCCESS = "DOWNLOAD_LEAVE_REQ_PDF_SUCCESS";
export const DOWNLOAD_LEAVE_REQ_PDF_FAIL = "DOWNLOAD_LEAVE_REQ_PDF_FAIL";

//DOWNLOAD_PUBLIC_HOLIDAY_XLSX
export const DOWNLOAD_PUBLIC_HOLIDAY_XLSX_REQUEST =
  "DOWNLOAD_PUBLIC_HOLIDAY_XLSX_REQUEST";
export const DOWNLOAD_PUBLIC_HOLIDAY_XLSX_SUCCESS =
  "DOWNLOAD_PUBLIC_HOLIDAY_XLSX_SUCCESS";
export const DOWNLOAD_PUBLIC_HOLIDAY_XLSX_FAIL =
  "DOWNLOAD_PUBLIC_HOLIDAY_XLSX_FAIL";

//DOWNLOAD_PUBLIC_HOLIDAY_CSV
export const DOWNLOAD_PUBLIC_HOLIDAY_CSV_REQUEST =
  "DOWNLOAD_PUBLIC_HOLIDAY_CSV_REQUEST";
export const DOWNLOAD_PUBLIC_HOLIDAY_CSV_SUCCESS =
  "DOWNLOAD_PUBLIC_HOLIDAY_CSV_SUCCESS";
export const DOWNLOAD_PUBLIC_HOLIDAY_CSV_FAIL =
  "DOWNLOAD_PUBLIC_HOLIDAY_CSV_FAIL";

//INDIVIDUAL_LEAVE_APPROVERS
export const INDIVIDUAL_LEAVE_APPROVERS_REQUEST =
  "INDIVIDUAL_LEAVE_APPROVERS_REQUEST";
export const INDIVIDUAL_LEAVE_APPROVERS_SUCCESS =
  "INDIVIDUAL_LEAVE_APPROVERS_SUCCESS";
export const INDIVIDUAL_LEAVE_APPROVERS_FAIL =
  "INDIVIDUAL_LEAVE_APPROVERS_FAIL";
